
export const AfterSalePermissions = {
  ViewAfterSale: {
    permissionsId: "7ae783b3-b2d8-42a6-a258-0d0f44c144f2",
    permissionsName: "View After Sales",
    description: null,
    componentsId: null,
    components: null,
  },
  CreateLead: {
    permissionsId: "f7d94d80-5cda-4106-b568-2fdf98b713bd",
    permissionsName: "Create Lead",
    description: null,
    componentsId: null,
    components: null,
  },
  AddReceipt: {
    permissionsId: "86040c51-ea62-4e64-b33d-407222c88551",
    permissionsName: "Add Receipt",
    description: null,
    componentsId: null,
    components: null,
  },
  LinkOffer: {
    permissionsId: "30d237c7-520d-49af-94bb-60feed0bb142",
    permissionsName: "Link Offer",
    description: null,
    componentsId: null,
    components: null,
  },
  AddActivity: {
    permissionsId: "54655ed1-1216-4445-9aef-787846561e4a",
    permissionsName: "add activity",
    description: null,
    componentsId: null,
    components: null,
  },
  ViewPayments: {
    permissionsId: "cf13e5f1-6d9d-45f7-a72f-ab07c58ba2f6",
    permissionsName: "View Payments",
    description: null,
    componentsId: null,
    components: null,
  },
  AddInvoice: {
    permissionsId: "d409b19e-4710-43f0-b16e-bf5da275ca45",
    permissionsName: "Add Invoice",
    description: null,
    componentsId: null,
    components: null,
  },
  ViewDocuments: {
    permissionsId: "93905f71-b2ec-4092-81d8-c436640f8de3",
    permissionsName: "View Documents",
    description: null,
    componentsId: null,
    components: null,
  },
  UploadDocument: {
    permissionsId: "cdac1598-891f-4080-8d43-cb28ed8124ef",
    permissionsName: "Upload Document",
    description: null,
    componentsId: null,
    components: null,
  },
  AssignAfterSalesOwner: {
    permissionsId: "c30fdff2-b5d7-4872-896a-e69499dcbfd2",
    permissionsName: "Assign After Sales Owner",
    description: null,
    componentsId: null,
    components: null,
  },
};
